<template>
<v-container fluid>
    <v-layout justify-center>
        <v-flex sm12 md10>
            <v-card title>
                <v-card-text>
                <Datatable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <GeneralDialog v-if="get_dialogMain.dialog" :form="formulario" action="procedencia.create-update"/>
</v-container>
</template>

<script>
// import router from '@/router'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import tableMain from '@/components/dataTableMain'
import GeneralDialog from '@/components/dialog/GeneralDialog'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'toCreateMarca', code: 'procedencia.create-update' }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    formulario: {
      fields: [
        {
          type: 'text',
          name: 'Nombre',
          nameid: 'nombre',
          field: 'text',
          cols: 6
        },
        {
          field: 'selectDataServer',
          name: 'Empresa',
          nameid: 'empresa_id',
          url: '/empresas',
          cols: 12
        }
      ]
    }
  }),
  mounted () {
    this.getDataUrl('inventario.procedencia.list')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  components: {
    Datatable: tableMain,
    GeneralDialog
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    toCreateMarca (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create', withWindows: 800, title: 'Nueva Procedencia' })
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('inventario.procedencia.list')
    },
    tableAction (item) {
      // acciones de cada row
      this[item.action](item)
    },
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('inventario.procedencia.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
